import { InputField, InputSelectFieldOptions } from 'components/molecules'
import { STATUS_OPTIONS } from 'domains/marketing-discount-batch/constants'

const MarketingDiscountBatchStatusField = () => (
  <>
    <InputField
      formGroupClassName={ 'mr-3' }
      type={ 'select' }
      name={ 'status' }
      label={ 'Status' }
      bsSize={ 'sm' }
    >
      <InputSelectFieldOptions
        options={ STATUS_OPTIONS }
      />
    </InputField>
  </>
)

export default MarketingDiscountBatchStatusField
